// src/pages/ProductPage.jsx
import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import API from "../services/api";

const ProductPage = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await API.get("/products/");
        const found = res.data.find((p) => p.id === parseInt(id));
        setProduct(found);
      } catch (err) {
        console.error("Error loading product:", err);
      }
    };

    fetchProduct();
  }, [id]);

  // 🟢 SHARE FUNCTION (TWITTER VIRAL LOOP)
  const handleShare = () => {
    if (!product) return;

    const url = `https://creator-mvp.pages.dev/product/${id}`;

    const text = `🔥 Check out this product: ${product.title} - ₦${product.price}`;

    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
      text
    )}&url=${encodeURIComponent(url)}`;

    window.open(twitterUrl, "_blank");
  };

  if (!product) return <h2>Loading product...</h2>;

  return (
    <div style={{ padding: 30, maxWidth: 600, margin: "0 auto" }}>

    

      {/* PRODUCT INFO */}
      <h1>{product.title}</h1>

      <p style={{ marginTop: 10, fontSize: 16 }}>
        {product.description}
      </p>

      <h2 style= {{ marginTop: 20 }}>₦{product.price}</h2>

      {/* Trust Signal */}
      <p style={{ marginTop: 10, color: "green", fontWeight: "bold" }}>
        ✔ Instant Download after payment  
      </p>

      {/* Urgency */}

      <p style={{ marginTop: 10, color: "red", fontWeight: "bold" }}>
        Limited early access Pricing 
      </p>

      {/* BUY BUTTON */}
      <Link to={`/checkout/${product.id}`}>
        <button 
        style={{ 
          padding: "12px 20px", 
          marginTop: 20,
          width: "100%",
          background: "#28a745",
          color: "#fff",
          border: "none",
          borderRadius: 5,
          fontSize: 16,
          }}
        >
          Buy Now
        </button>
      </Link>

      {/* 🟢 SHARE BUTTON (VIRAL ENGINE) */}
      <button
        onClick={handleShare}
        style={{
          padding: "10px 20px",
          marginTop: 15,
          marginLeft: 10,
          background: "#1DA1F2",
          color: "#fff",
          border: "none",
          borderRadius: 5,
          cursor: "pointer",
        }}
      >
        Share on Twitter
      </button>
    </div>
  );
};

export default ProductPage;